var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2 3.25h1.25V2H2zM5 3.25h13V2H5zM3.25 7.25H2V6h1.25zM18 7.25H5V6h13zM6.25 11H5V9.75h1.25zM18 11H8V9.75h10zM3.25 18H2v-1.25h1.25zM18 18H5v-1.25h13zM5 14h1.25v-1.25H5zM8 14h10v-1.25H8z"
})));
export default SvgOutline;